import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
} from "@mui/material";
import SelectUser from "../generic/SelectUser";

export default function ForwardResponseDialog({ open, onClose, onForward }) {
  const [newRespondedor, setNewRespondedor] = useState(null);

  const handleForward = () => {
    if (newRespondedor) {
      onForward(newRespondedor);
      setNewRespondedor(null);
    }
  };

  const handleClose = () => {
    setNewRespondedor(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Reenviar a otro respondedor</DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <SelectUser
            multiple={false}
            userType="users"
            value={newRespondedor}
            setValue={setNewRespondedor}
            placeholder="Seleccionar nuevo respondedor/a"
            onChange={(__, value) => setNewRespondedor(value)}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button
          onClick={handleForward}
          variant="contained"
          disabled={!newRespondedor}
        >
          Reenviar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
